import { Outlet } from "react-router-dom";
import Header from "./components/Header";

function App() {
  return (
    <div>
      <Header />
      {/* Used in parents route to render its children routes*/}
      <Outlet />
    </div>
  );
}

export default App;
